<template>
    <md-card>
        <md-card-header class="md-card-header-icon md-card-header-danger">
            <div class="md-layout">
                <div class="md-layout-item">
                    <div class="card-icon">
                        <font-awesome-icon class="md-icon" :icon="['fa', 'bars']"></font-awesome-icon>
                    </div>
                    <h4 class="title">{{ title }}</h4>
                </div>
                <div class="md-layout-actions md-layout-item md-size-40 text-right align-center mt-3">
                    <div class="flex items-center justify-end header-actions">
                        <div>
                            <md-button class="md-icon-button md-raised md-info"
                                       @click="goToRoute('Add Intervention')">
                                <font-awesome-icon class="md-icon" :icon="['fa', 'plus']" />
                                <span class="leading-none ml-2">Ajouter une intervention</span>
                            </md-button>
                        </div>
                    </div>
                </div>
            </div>
        </md-card-header>
        <md-card-content>
            <md-table class="paginated-table" table-header-color="red"
                      :value="interventions">
                <md-table-toolbar>
                    <md-field>
                        <label for="pages">Éléments à afficher</label>
                        <md-select v-model="pagination.perPage" id="pages" name="pages">
                            <md-option
                                v-for="item in pagination.perPageOptions"
                                :key="item" :label="item" :value="item">
                                {{ item }}
                            </md-option>
                        </md-select>
                    </md-field>

                    <md-field>
                        <md-input
                            type="search"
                            clearable
                            style="width: 250px"
                            placeholder="Rechercher..."
                            v-model="searchQuery"
                        >
                        </md-input>
                    </md-field>
                </md-table-toolbar>

                <md-table-row slot="md-table-row" slot-scope="{ item }">
                    <md-table-cell md-label="#" style="max-width: max-content;">
                        <span class="pr-4">{{ item.id }}</span>
                    </md-table-cell>
                    <md-table-cell md-label="Date" style="max-width: 75px;">
                        {{  getStartDate(item.planningable.start_date) }}
                    </md-table-cell>
                    <md-table-cell md-label="Début" style="max-width: 50px;">
                        {{ getStartHours(item.planningable.start_date) }}
                    </md-table-cell>
                    <md-table-cell md-label="Fin" style="max-width: 50px;">
                        {{ getEndHours(item.planningable.end_date) }}
                    </md-table-cell>
                    <md-table-cell md-label="Durée" style="max-width: 50px;">
                        {{ item.duration + 'm' }}
                    </md-table-cell>
                    <md-table-cell md-label="Client">
                        {{ item.site ? item.site.client.name : '' }}
                    </md-table-cell>
                    <md-table-cell md-label="Technicien" style="max-width: 100px;">
                        {{ item.technician.full_name }}
                    </md-table-cell>
                    <md-table-cell md-label="" style="max-width: 50px;">
                        <div class="mr-1">
                            <md-button class="md-icon-button md-raised md-info">
                                <font-awesome-icon class="md-icon" :icon="['fa', 'download']"></font-awesome-icon>
                            </md-button>
                            <md-tooltip md-direction="top">Télécharger le rapport</md-tooltip>
                        </div>
                        <md-button class="md-icon-button md-raised md-info">Fixe</md-button>
                    </md-table-cell>
                </md-table-row>
            </md-table>
        </md-card-content>
        <md-card-actions md-alignment="space-between">
            <p class="card-category">
                Affichage des éléments {{ from + 1 }} à {{ to }} sur {{ pagination.total }} éléments
            </p>
            <pagination
                class="pagination-no-border pagination-info"
                v-model="pagination.currentPage"
                :per-page="pagination.perPage"
                :total="pagination.total"
                @input="getInterventions"
            >
            </pagination>
        </md-card-actions>
    </md-card>
</template>

<script>
import { Pagination } from "@/components";
import moment from "moment";

export default {
    name: "InterventionCanceled",
    components: {
        Pagination
    },
    props: {
        title: String,
        active: Boolean,
    },
    data() {
        return {
            interventions: [],
            technicians: [],
            pagination: {
                perPage: 100,
                currentPage: 1,
                perPageOptions: [10, 25, 50, 100],
                total: 0
            },
            searchQuery: "",
            propsToSearch: ["name"],
            searchedData: [],
            fuseSearch: null
        }
    },
    computed: {
        queriedData() {
            let result = this.interventions;
            if (this.searchedData.length > 0) {
                result = this.searchedData;
            }
            return result.slice(this.from, this.to);
        },
        to() {
            let highBound = this.from + this.pagination.perPage;
            if (this.pagination.total < highBound) {
                highBound = this.pagination.total;
            }
            return highBound;
        },
        from() {
            return this.pagination.perPage * (this.pagination.currentPage - 1);
        },
        total() {
            return this.searchedData.length > 0
                ? this.searchedData.length
                : this.interventions.length;
        },
    },
    methods: {
        async getInterventions() {
            const response = await this.$store.dispatch('interventions/getInterventions', {
                type: 'canceled',
                page: this.pagination.currentPage,
                perPage: this.pagination.perPage,
                search: this.searchQuery
            })
            this.interventions = response.data.data
            this.pagination.total = response.data.total
        },
        goToRoute(route, params = null) {
            this.$router.push({ name: route, params })
        },
        getStartDate(date) {
            return moment(date).format('DD/MM/YYYY')
        },
        getStartHours(date) {
            return moment(date).format('H:m')
        },
        getEndHours(date) {
            return moment(date).format('H:m')
        }
    },
    mounted() {
        if(this.active) {
            this.getInterventions()
        }
    },
    watch: {
        active: function(newVal, oldVal) {
            if(newVal) {
                this.getInterventions()
            }
        },
        searchQuery() {
            this.getInterventions()
        }
    }
}
</script>

<style scoped>

</style>
